import React from 'react'

import OMImage from  '@probatix/myprobatix/assets/ogimage.png'

const Meta = ({ lang }: { lang: string }) => (
  <React.Fragment>
    <meta charSet="utf-8" />
    <meta
      content="Entdecken Sie eine bequeme Art, Ihre Gesundheit zu überwachen,
      mit einer Reihe von Tests von Probatix Health, einschließlich Bluttests für Vitamine,
      Allergien und Organfunktionen. Einfache Buchung, digitale Ergebnisse und bundesweite
      Apothekenpartnerschaften für Ihre Gesundheitsbedürfnisse"
      name="description"
    />
    <meta content={lang} httpEquiv="content-language" />
    <meta content="apothekendiagnostik, gesundheitstests, apotheke, diagnose, gesundheit" name="keywords" />
    <meta content="Probatix" name="author" />
    <meta content="width=device-width, initial-scale=1.0, maximum-scale=1" name="viewport" />
    <title>Probatix Health</title>
    <meta content="Probatix Health" property="og:site_name" />
    <meta content={lang} property="og:locale" />
    <meta content="Probatix Health - Einfache und zugängliche Gesundheitstestdienste" property="og:title" />
    <meta content="website" property="og:type" />
    <meta content="https://probatix.de/" property="og:url" />
    <meta content={OMImage} property="og:image" />
    <meta
      content="Entdecken Sie eine bequeme Art, Ihre Gesundheit zu überwachen,
      mit einer Reihe von Tests von Probatix Health, einschließlich Bluttests für Vitamine,
      Allergien und Organfunktionen. Einfache Buchung, digitale Ergebnisse und bundesweite
      Apothekenpartnerschaften für Ihre Gesundheitsbedürfnisse"
      property="og:description"
    />
  </React.Fragment>
)

export default Meta
